export default "__VITE_ASSET__BMsKlA95__"